import { sharedColors } from '../sharedStyles'

const flexColumn = {
  display: 'flex',
  flexDirection: 'column',
}

const makeAssetBaseStyles = (maintainAspectRatio, asset) => ({
  backgroundColor: sharedColors.imageBackground,

  ...(maintainAspectRatio && {
    maxBlockSize: 470,
    minBlockSize: asset ? 196 : 375,
    overflow: 'hidden',
  }),
})

const makeAssetStyles = (maintainAspectRatio, asset) => ({
  video: {
    inlineSize: 375,
    minBlockSize: 375,
    maxBlockSize: '100%',
    objectFit: 'cover',
  },

  ...(maintainAspectRatio && {
    display: 'flex', // Ensure container fits to size of asset
    maxBlockSize: 470,
    minBlockSize: asset ? 196 : 375,
    img: {
      maxBlockSize: 470,
      minBlockSize: asset ? 196 : 470,
    },
    video: {
      inlineSize: 375,
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'cover',
    },
  }),
})

export const styles = {
  flexColumn,
  makeAssetBaseStyles,
  makeAssetStyles,
}
